import React, { useState, useEffect, useContext } from 'react'
import turf from '@turf/length'
import { lineString } from '@turf/helpers'
// import {LayerContext} from '../../../../../data/AppContext'
import Grow from '@material-ui/core/Grow'
import Tooltip from '@material-ui/core/Tooltip'
// import { LayerContext } from '../../data/AppContext'
//import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ClearLogo from '../../../../assets/eraser-tool.png'
// import LogoRuler from '../../../../assets/ruler.png'
import './ruler.css'

function Ruler(props) {
  const [ruler, setRuler] = useState(false)
  const [distance, setDistance] = useState([])

  // useEffect(() => {
  //   printDistance()
  // }, [distance])

  // const showRuler = (info) => {
  //   setRulerActive(info)
  //   if (!ruler) setRuler(true)
  //   if (ruler) setRuler(false)
  // }

  // const printDistance = () => {
  //   if (distance.length < 2) console.log('se nececitan dos puntos')
  //   if (distance.length >= 2) setDistance2(turf(lineString(distance), { units: 'kilometers' }))
  // }

  return (
    <div>
      {/*toolsMenu.ruler === false ? (
        <Tooltip title="Ruler Tool" placement="top" arrow>
          <div
            className="ruler-select"
            onClick={() => {
              showRuler(true)
              ToggleToolsMenu('ruler')
            }}
          >
            <img src={LogoRuler} className="icon-align-inf" />
          </div>
        </Tooltip>
      ) : (
        <div
          className="ruler-select"
          style={{ backgroundColor: '#d4d9df' }}
          onClick={() => {
            showRuler(false)
            ToggleToolsMenu('close')
          }}
        >
          <img src={LogoRuler} className="icon-align-inf" />
        </div>
      )*/}

      <Grow in={props.menu[0].view}>
        <div className="ruler-menu">
          <div className="ruler-lbl-container">
            <label className="distance-txt">
              {Intl.NumberFormat('en-US').format(props.lbl.toFixed(2))}&nbsp;&nbsp;km
            </label>
          </div>
          <button
            className="ruler-btn"
            onClick={() => {
              props.delete()
              props.setPointer('Ruler Tool', true)
            }}
          >
            {' '}
            <img src={ClearLogo} className="icon-align-inf" />{' '}
          </button>
        </div>
      </Grow>
    </div>
  )
}

export default Ruler
